module.exports = __webpack_public_path__ + "static/media/fileadd.45ba24a1.svg";